// PageSlide.js
// Wraps a screen so it slides in from the right when it mounts (route change),
// making navigation feel like a proper slider instead of a hard cut. While the
// slide plays we clip horizontal overflow on <body> so the off-screen page
// doesn't flash a horizontal scrollbar.
import React, { useEffect } from "react";
import styles from "./PageSlide.module.css";

const PageSlide = ({ children, className = "" }) => {
  useEffect(() => {
    const body = document.body;
    const prevX = body.style.overflowX;
    body.style.overflowX = "hidden";
    const t = setTimeout(() => {
      body.style.overflowX = prevX;
    }, 380); // slightly longer than 350ms slide animation
    return () => {
      clearTimeout(t);
      body.style.overflowX = prevX;
    };
  }, []);

  return <div className={`${styles.slide} ${className}`}>{children}</div>;
};

export default PageSlide;
